import { render, staticRenderFns } from "./VMaskedInput.vue?vue&type=template&id=52ea7ad2&scoped=true&"
import script from "./VMaskedInput.vue?vue&type=script&lang=js&"
export * from "./VMaskedInput.vue?vue&type=script&lang=js&"
import style0 from "./VMaskedInput.vue?vue&type=style&index=0&id=52ea7ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea7ad2",
  null
  
)

export default component.exports